import { get, post, put, destroy } from './base';


export const ReportsServe = {
    getReport: (payload) =>
        post('/reports', payload),

generateLPReport: (payload) =>
  get(
    `/reports/internal-lp-report?fromDate=${encodeURIComponent(payload.fromDate)}&toDate=${encodeURIComponent(payload.toDate)}`
  ),
}